
export const CREATE_CLIP_REQUEST_GET_REQUEST = "CREATE_CLIP_REQUEST_GET_REQUEST";
export const CREATE_CLIP_REQUEST_GET_RESULT = "CREATE_CLIP_REQUEST_GET_RESULT";
export const CREATE_CLIP_REQUEST_OPEN_MODAL = "CREATE_CLIP_REQUEST_OPEN_MODAL";
export const CREATE_CLIP_REQUEST_REQUEST = "CREATE_CLIP_REQUEST_REQUEST";
export const CREATE_CLIP_REQUEST_RESULT = "CREATE_CLIP_REQUEST_RESULT";